import { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import historyLog from 'services/history-log';
import throwException from 'utils/throwException';
import TableBase from 'components/TableBase';
import { find, get } from 'lodash';
import moment from 'moment';

interface IProps {
  t: any;
  onRef?: any;
}

interface IState {
  data: any[];
  loading: boolean;
  totalDocs: number;
}

interface SendMailStatus {
  eventType: string;
  mail: any;
  sent?: any;
  delivery?: any;
}

class LogEmail extends Component<IProps, IState> {
  page_number: number;
  namesearch: any;
  category_notify: any;
  start_date: any;
  end_date: any;
  constructor(props: IProps) {
    super(props);
    this.state = { data: [], loading: false, totalDocs: 0 };
    this.page_number = 1;
    this.namesearch = '';
  }

  componentDidMount() {
    const { onRef } = this.props;
    if (onRef) onRef(this);
  }

  shouldComponentUpdate(_, nState: IState) {
    const { loading, totalDocs, data } = this.state;
    return loading !== nState.loading || totalDocs !== nState.totalDocs || data !== nState.data;
  }

  componentWillUnmount() {
    const { onRef } = this.props;
    if (onRef) onRef(undefined);
  }

  renderCategoryNotifi = (): any[] => {
    const { t } = this.props;
    return [
      {
        value: '',
        text: t('history_log.option.category_notify.all'),
      },
      {
        value: 'new_incident',
        text: t('history_log.option.category_notify.new_incident'),
      },
      {
        value: 'new_message',
        text: t('history_log.option.category_notify.new_message'),
      },
      {
        value: 'other',
        text: t('history_log.option.category_notify.other'),
      },
      // {
      //   value: 'new_admin',
      //   text: t('history_log.option.category_notify.new_admin'),
      // },
      // {
      //   value: 'tfa_vertification',
      //   text: t('history_log.option.category_notify.tfa_vertification'),
      // },
      // {
      //   value: 'reset_password',
      //   text: t('history_log.option.category_notify.reset_password'),
      // },
      // {
      //   value: 'reset_password_success',
      //   text: t('history_log.option.category_notify.reset_password_success'),
      // },
      // {
      //   value: 'lockout_user',
      //   text: t('history_log.option.category_notify.lockout_user'),
      // },
      // {
      //   value: 'lockout_admin',
      //   text: t('history_log.option.category_notify.lockout_admin'),
      // },
      // {
      //   value: 'lockout_removed',
      //   text: t('history_log.option.category_notify.lockout_removed'),
      // },
      // {
      //   value: 'role_update',
      //   text: t('history_log.option.category_notify.role_update'),
      // },
      // {
      //   value: 'incident_assigned',
      //   text: t('history_log.option.category_notify.incident_assigned'),
      // },
      // {
      //   value: 'incident_shared',
      //   text: t('history_log.option.category_notify.incident_shared'),
      // },
      // {
      //   value: 'deactive_admin',
      //   text: t('history_log.option.category_notify.deactive_admin'),
      // },
      // {
      //   value: 'reactive_admin',
      //   text: t('history_log.option.category_notify.reactive_admin'),
      // },
      // {
      //   value: 'ip_blocked',
      //   text: t('history_log.option.category_notify.ip_blocked'),
      // },
      // {
      //   value: 'ip_unblocked',
      //   text: t('history_log.option.category_notify.ip_unblocked'),
      // },
      // {
      //   value: 'org_deleted',
      //   text: t('history_log.option.category_notify.org_deleted'),
      // },
    ];
  };

  getCurrenStatus = (data: SendMailStatus[]) => {
    let status_ses = ['Delivery', 'Bounce', 'DeliveryDelay', 'Send', 'RenderingFailure'];
    for (let i = 0; i < status_ses.length; i++) {
      let value = data.find((el) => el.eventType === status_ses[i]);
      if (value) return value;
    }
    return null;
  };

  renderCategoryNotifiTable = (): any[] => {
    const { t } = this.props;
    return [
      {
        value: '',
        text: t('history_log.option.category_notify.all'),
      },
      {
        value: 'new_incident',
        text: t('history_log.option.category_notify.new_incident'),
      },
      {
        value: 'new_message',
        text: t('history_log.option.category_notify.new_message'),
      },
      {
        value: 'new_admin',
        text: t('history_log.option.category_notify.new_admin'),
      },
      {
        value: 'tfa_vertification',
        text: t('history_log.option.category_notify.tfa_vertification'),
      },
      {
        value: 'reset_password',
        text: t('history_log.option.category_notify.reset_password'),
      },
      {
        value: 'reset_password_success',
        text: t('history_log.option.category_notify.reset_password_success'),
      },
      {
        value: 'lockout_user',
        text: t('history_log.option.category_notify.lockout_user'),
      },
      {
        value: 'lockout_admin',
        text: t('history_log.option.category_notify.lockout_admin'),
      },
      {
        value: 'lockout_removed',
        text: t('history_log.option.category_notify.lockout_removed'),
      },
      {
        value: 'role_update',
        text: t('history_log.option.category_notify.role_update'),
      },
      {
        value: 'incident_assigned',
        text: t('history_log.option.category_notify.incident_assigned'),
      },
      {
        value: 'incident_shared',
        text: t('history_log.option.category_notify.incident_shared'),
      },
      {
        value: 'deactive_admin',
        text: t('history_log.option.category_notify.deactive_admin'),
      },
      {
        value: 'reactive_admin',
        text: t('history_log.option.category_notify.reactive_admin'),
      },
      {
        value: 'ip_blocked',
        text: t('history_log.option.category_notify.ip_blocked'),
      },
      {
        value: 'ip_unblocked',
        text: t('history_log.option.category_notify.ip_unblocked'),
      },
      {
        value: 'org_deleted',
        text: t('history_log.option.category_notify.org_deleted'),
      },
      {
        value: 'new_password_success',
        text: t('history_log.option.category_notify.new_password_success'),
      },
    ];
  };

  handleError = (e) => {
    this.setState({ loading: false });
    throwException(e);
  };

  getData = () => {
    const { loading } = this.state;
    // if (!this.start_date || !this.end_date) {
    //   this.setState({ loading: false, data: [] });
    //   return;
    // }
    if (!loading) this.setState({ loading: true });

    historyLog
      .list({
        page_size: 10,
        page: this.page_number,
        search: this.namesearch,
        type: 'EMAIL',
        notice_category: this.category_notify || '',
        start_date: this.start_date
          ? moment(this.start_date, 'YYYY/MM/DD').format('YYYY/MM/DD') + ' 00:00:00'
          : null,
        end_date: this.end_date
          ? moment(this.end_date, 'YYYY/MM/DD').format('YYYY/MM/DD') + ' 23:59:59'
          : null,
      })
      .then(({ data }) => {
        const { docs, totalDocs } = data.data;
        this.setState({ data: docs, loading: false, totalDocs });
      })
      .catch(this.handleError);
  };
  renderColumns = (): any[] => {
    const { t } = this.props;
    let category = this.renderCategoryNotifiTable();
    const columns = [
      {
        title: t('history_log.email.column.title'),
        dataIndex: 'email',
        width: 450,
      },
      {
        title: t('history_log.account_name.column.title'),
        dataIndex: 'org_root_id',
        width: 200,
        render: (v) => <div>{get(v, 'name')}</div>,
      },
      {
        title: t('history_log.org.column.title'),
        dataIndex: 'org_id',
        width: 200,
        render: (v) => <div>{get(v, 'name')}</div>,
      },
      {
        title: t('history_log.incident_id.column.title'),
        dataIndex: 'incident_id',
        width: 200,
        render: (v) => <div>{get(v, 'sequence', '')}</div>,
      },
      {
        title: t('history_log.notice_category.column.title'),
        dataIndex: 'notice_category',
        width: 200,
        render: (v) => {
          let getCategoryNotifi = find(category, (item) => {
            return get(item, 'value', '') === v;
          });
          return (
            <div>
              {get(getCategoryNotifi, 'text', t('history_log.option.category_notify.other'))}
            </div>
          );
        },
      },
      {
        title: t('history_log.sent_time_standby.column.title'),
        dataIndex: 'standby_to_server',
        width: 200,
        render: (v) => <div>{moment(v).format('YYYY/MM/DD, HH:mm')}</div>,
      },
      {
        title: t('history_log.sent_status_standby.column.title'),
        dataIndex: 'status_send_to_server',
        width: 200,
        render: (v) => (
          <div>
            {v === 'OK'
              ? t('history_log.sent_from_server.status.OK')
              : t('history_log.sent_from_server.status.NG')}
          </div>
        ),
      },
      {
        title: t('history_log.sent_time_ses.column.title'),
        dataIndex: 'server_to_customer_logs',
        width: 200,
        render: (v) => (
          <div>{v[0] ? moment(v[0].mail.timestamp).format('YYYY/MM/DD HH:mm') : ''}</div>
        ),
      },
      {
        title: t('history_log.tranmission_result.column.title'),
        dataIndex: 'server_to_customer_logs',
        width: 200,
        render: (v) => {
          let last_status = this.getCurrenStatus(v);
          return (
            <div>
              {last_status
                ? t(`history_log.ses_status.${last_status.eventType}`)
                : t(`history_log.ses_status.Pending`)}
            </div>
          );
        },
      },
    ];
    return columns;
  };
  handleSearch = (e) => {
    const { value = '' } = e.target;
    this.namesearch = value.trim();
    const { data } = this.state;
    this.page_number = 1;
    if (this.namesearch.length < 5) {
      if (data.length) {
        this.setState({ data: [], totalDocs: 0 });
      }
      return;
    }
    this.getData();
  };

  handleSearchOption = (value) => {
    const { data } = this.state;
    this.category_notify = value;
    this.page_number = 1;
    if (this.namesearch.length < 5) {
      if (data.length) {
        this.setState({ data: [], totalDocs: 0 });
      }
      return;
    }
    this.getData();
  };

  handleSearchDateTime = (value) => {
    const { data } = this.state;
    this.start_date = value[0];
    this.end_date = value[1];
    this.page_number = 1;
    if (this.namesearch.length < 5) {
      if (data.length) {
        this.setState({ data: [], totalDocs: 0 });
      }
      return;
    }
    this.getData();
  };

  handleChangePage = (page) => {
    this.page_number = page;
    this.getData();
  };

  exportLog = () => {
    const { loading } = this.state;
    // if (!this.start_date || !this.end_date) {
    //   this.setState({ loading: false, data: [] });
    //   return;
    // }
    if (!loading) this.setState({ loading: true });

    const params: any = {
      page_size: 10,
      page: this.page_number,
      search: this.namesearch || '',
      type: 'EMAIL',
      notice_category: this.category_notify || '',
      start_date: this.start_date
        ? moment(this.start_date, 'YYYY/MM/DD').format('YYYY/MM/DD') + ' 00:00:00'
        : '',
      end_date: this.end_date
        ? moment(this.end_date, 'YYYY/MM/DD').format('YYYY/MM/DD') + ' 23:59:59'
        : '',
      standby_token: localStorage.getItem('access_token'),
    };
    const queryString = new URLSearchParams(params).toString();
    window.open(process.env.REACT_APP_API_URL + '/admin/email-sms-log/excel?' + queryString);
    this.setState({ loading: false });
  };

  render() {
    const { loading, data, totalDocs } = this.state;
    return (
      <Fragment>
        <TableBase
          style={{ margin: 0 }}
          scroll={{ x: 1000 }}
          pagination={{
            pageSize: 10,
            onChange: this.handleChangePage,
            total: totalDocs,
            current: this.page_number,
          }}
          // onOkFormAdd={this.handleOkAdd}
          handleSearch={this.handleSearch}
          handleSearchOption={this.handleSearchOption}
          dataOption={this.renderCategoryNotifi()}
          handleSearchDateTime={this.handleSearchDateTime}
          loading={loading}
          lableKeyI18n="content.management.button.add_new_article"
          widthModalAdd={791}
          rowKey="_id"
          dataSource={data}
          columns={this.renderColumns()}
          typeSearch={'email'}
        />
      </Fragment>
    );
  }
}

export default withTranslation()(LogEmail);
